export function PageHeader({ title, subtitle, icon: Icon, actions }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between animate-fade-up">
      <div className="flex items-start gap-3">
        {Icon && (
          <div className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-red/10 text-brand-red">
            <Icon className="h-5 w-5" />
          </div>
        )}
        <div>
          <h1 className="font-heading text-3xl font-extrabold tracking-tight text-brand-ink">
            {title}
          </h1>
          {subtitle && <p className="mt-1 max-w-2xl text-sm text-brand-mute">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
